enum CODE {
  MISSING_PERMISSIONS = 403,
  MISSING_VIEW = 404
}

const NOT_ALLOWED_VIEW = {
  MISSING_PERMISSIONS: {
    code: CODE.MISSING_PERMISSIONS,
    description: 'Lo sentimos, no tienes permisos suficientes para visualizar este contenido.'
  }
}

export {
  NOT_ALLOWED_VIEW
}
